module.exports = __webpack_public_path__ + "images/花筑pr长图_01.jpg?v=2610b276";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_01.jpg
 ** module id = 11
 ** module chunks = 1 2
 **/